/* eslint-disable react-hooks/exhaustive-deps */
import OwlCarousel from 'react-owl-carousel2';
import '../../../common/css/owl.carousel.css';
import { Link } from 'react-router-dom';
import { useEffect, useMemo, useRef } from 'react';
import ImageLoader from '../ImageLoader';
import { buildSafeLink } from '../../../utils/helper';

const Banner = (props) => {
	const { className = '', data = [], isLoading = true } = props;

	const activeIndexRef = useRef(0);
	const carouselRef = useRef(null);
	const intervalRef = useRef(null);
	const resumeTimeout = useRef(null);

	useEffect(() => {
		if (isLoading || !data?.length) return;

		// clear dulu kalau ada
		clearInterval(intervalRef.current);

		intervalRef.current = setInterval(() => {
			const nextIndex = (activeIndexRef.current + 1) % data?.length;

			activeIndexRef.current = nextIndex;

			carouselRef.current?.goTo(nextIndex);
		}, 5000);

		return () => clearInterval(intervalRef.current);
	}, [data, isLoading]);

	const handleUserInteraction = () => {
		// pause
		clearInterval(intervalRef.current);
		clearTimeout(resumeTimeout.current);

		// resume setelah 10 detik
		resumeTimeout.current = setTimeout(() => {
			intervalRef.current = setInterval(() => {
				const nextIndex = (activeIndexRef.current + 1) % data?.length;
				activeIndexRef.current = nextIndex;
				carouselRef.current?.goTo(nextIndex);
			}, 5000);
		}, 10000);
	};

	const bannerOptions = {
		items: 1,
		dots: false,
		loop: false,
		margin: 0,
		stagePadding: 0,
		stageOuterClass: 'owl-stage-outer w-full min-w-full',
		stageClass: '!pl-0',
		autoplay: false,
	};

	const itemsToRender = useMemo(() => {
		if (isLoading) {
			return Array.from({ length: 3 }, (_, i) => ({
				id: `skeleton-${i}`,
				isSkeleton: true,
			}));
		}

		if (!data?.length) return [];

		return data.map((item) => ({
			...item,
			banner_link: buildSafeLink(item?.banner_link),
			isSkeleton: false,
		}));
	}, [data, isLoading]);

	const events = useMemo(
		() => ({
			onChanged: (event) => {
				const index = event?.item?.index ?? 0;
				const realIndex = itemsToRender.length ? index % itemsToRender.length : 0;

				activeIndexRef.current = realIndex;
			},
		}),
		[itemsToRender.length],
	);

	return (
		<div className={`${className}`}>
			<>
				<OwlCarousel ref={carouselRef} key={data?.length} options={bannerOptions} events={events}>
					{itemsToRender.map((item, index) => {
						const isSkeleton = item?.isSkeleton;

						return (
							<div
								key={item.id || item.banner_id || `banner-${index}`}
								className='relative h-auto w-full min-w-full'
								onTouchStart={handleUserInteraction}
								onPointerDown={handleUserInteraction}
								onFocus={handleUserInteraction}
								tabIndex={0}>
								{isSkeleton ? (
									<div className='w-full h-[160px] shimmer rounded-lg' />
								) : (
									<Link to={item?.banner_link} className='w-full min-w-full h-full transition-all duration-500 ease-in-out bg-blue-500' rel={item?.banner_link ? 'noreferrer' : undefined} target='_self'>
										<ImageLoader src={item?.banner_image} alt={`banner-${index}`} className='w-full min-w-full h-full !max-h-[200px] object-fill' />
									</Link>
								)}
							</div>
						);
					})}
				</OwlCarousel>
				<div className='absolute left-[50%] bottom-[15%] flex gap-1 z-[1]'>
					{itemsToRender.map((_, i) => (
						<div key={i} className={`w-1.5 h-1.5 rounded-full transition-all duration-500 ease-in-out ${i === activeIndexRef.current ? 'bg-white' : 'bg-white/40'}`} />
					))}
				</div>
			</>
		</div>
	);
};

export default Banner;
